import React from 'react'
import { Helmet } from 'react-helmet';
import Aman from '../assets/images/Aman.png'
import Ashwani from '../assets/images/Ashwani.png'
import Arushi from '../assets/images/Arushi.png'
import Hiren from '../assets/images/Hiren.png'
import VimalMishra from '../assets/images/vimal mishra.png'
import ContactForm from '../components/ContactForm';

const Contact = () => {
    return (
        <div>
            <Helmet>
                <title>Contact Us | GeoID</title>
            </Helmet>
            <div className='main-container'>
                <div className="section-heading">
                    <h1>
                        Contact Us
                    </h1>
                </div>

                <div className="section">
                    <div className="row">
                        <div className="column-2">
                            <div className="contact-image">
                                <img src={VimalMishra} alt="Vimal Mishra" rel="noreferrer noopener"/>
                            </div>
                            <div className="contact-image-caption">
                                <p>
                                    <a href="https://scholar.google.co.in/citations?user=wq7CgpUAAAAJ&hl=en" target="_blank" rel="noreferrer noopener"> Dr.
                                        Vimal Mishra </a><br />
                                        Supervisor<br/>
                                    Professor, Civil Engineering <br />IIT Gandhinagar<br />
                                   
                                </p>
                            </div>
                        </div>

                        <div className="column-2">
                            <div className="contact-image">
                                <img src={Hiren} alt="Hiren" />
                            </div>
                            <div className="contact-image-caption">
                                <p>
                                    <a href="https://www.linkedin.com/in/hiren-solanki-831286135/" target="_blank" rel="noreferrer noopener"> 
                                    Hiren Solanki </a><br />
                                    Team Leader<br/>
                                    PhD, Civil Engineering, <br />
                                    IIT Gandhinagar<br />
                                   
                                </p>
                            </div>
                        </div>

                        <div className="column-2">
                            <div className="contact-image">
                                <img src={Arushi} alt="Arushi" />
                            </div>
                            <div className="contact-image-caption">
                                <p>
                                    <a href="https://www.linkedin.com/in/arushi-arnav-657389193/" target="_blank" rel="noreferrer noopener"> 
                                    Arushi Arnav </a><br />
                                    Risk Assessment Analyst<br/>
            
                                    B.Tech. Civil Engineering<br />
                                    IIT Gandhinagar<br />
                                   
                                </p>
                            </div>
                        </div>

                        <div className="column-2">
                            <div className="contact-image">
                                <img src={Ashwani} alt="Ashwani" />
                            </div>
                            <div className="contact-image-caption">
                                <p>
                                    <a href="https://www.linkedin.com/in/ashwani-rai07/" target="_blank" rel="noreferrer noopener"> 
                                    Ashwani Rai </a><br />
                                    GIS Analyst<br/>
                                    B.Tech. Civil Engineering<br />
                                    IIT Gandhinagar<br />
                                   
                                </p>
                            </div>
                        </div>

                        <div className="column-2">
                            <div className="contact-image">
                                <img src={Aman} alt="Aman" />
                            </div>
                            <div className="contact-image-caption">
                                <p>
                                    <a href="https://www.linkedin.com/in/aman-chaudhary-4a1716203/" target="_blank" rel="noreferrer noopener"> 
                                    Aman Chaudhary</a><br />
                                    Web Developer<br/>
                                    B.Tech. Civil Engineering<br />
                                    IIT Gandhinagar<br />
                                   
                                </p>
                            </div>
                        </div>

                    </div>
                </div>

                <div className="section">
                    <div className="row">
                    <div className="column-6">
                            <ContactForm/>
                        </div>
                        <div className="column-6">
                            <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d35865.5629622251!2d72.67216585808931!3d23.21341831585334!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xdc447b8706689bc3!2sIndian%20Institute%20Of%20Technology%E2%80%93Gandhinagar%20(IIT%E2%80%93Gandhinagar)!5e0!3m2!1sen!2sin!4v1662577700931!5m2!1sen!2sin"
                                width="100%" height="400" style={{ border: 0 }} allowFullScreen="" aria-hidden="false" tabIndex={0}
                                referrerPolicy="no-referrer-when-downgrade" title="map">
                            </iframe>

                        </div>
                        
                    </div>

                </div>

            </div>
        </div>

    )
}

export default Contact
